import React from "react"
import { Backdrop, CircularProgress } from "@material-ui/core"
import { makeStyles } from "@material-ui/core/styles"
import Spinner from "../../../../src/components/Spinner/index"
import * as Adm from "@adm"

const BackDropOverLayStyles = makeStyles((theme) => ({
  backdrop: (props) => ({
    zIndex: props?.zIndex ? props.zIndex : 1600,
    color: "white",
  }),
}))

function BackdropOverlay({ open = false, zIndex = 1600 }) {
  const classes = BackDropOverLayStyles({ zIndex })
  React.useEffect(() => {
    if (open) {
      document.body.classList.add("cls-backdrop-overlay-kit")
    } else {
      document.body.classList.remove("cls-backdrop-overlay-kit")
    }
    return () => {
      document.body.classList.remove("cls-backdrop-overlay-kit")
    }
  }, [open])

  return (
    <Backdrop
      open={open}
      style={{ zIndex: zIndex || 1600 }}
      className={`${classes.backdrop} cls-Backdrop-load-kit`}
    >
      <Adm.BrandLoadingBar />
    </Backdrop>
  )
}
export { BackdropOverlay }
export default BackdropOverlay
